export const LOCATION_SEARCH_RESULTS_MAX_DISPLAY_COUNT = 10;
export const LOCATION_SEARCH_DEBOUNCE_MILLISECONDS = 500;
